export default __webpack_public_path__ + "static/media/tiendaOnline.fd62b3be.svg";